export const downloadFile = (url: string, filename?: string) => {
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.style.display = 'none';

  if (filename) {
    anchor.download = filename;
  }

  document.body.appendChild(anchor);

  const clickEvent = new MouseEvent('click', {
    bubbles: false,
    cancelable: false,
  });

  anchor.dispatchEvent(clickEvent);
  document.body.removeChild(anchor);
};

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);

  downloadFile(url, filename);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
